"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTableCapacityTooLow = isTableCapacityTooLow;
exports.isTableCapacityTooHigh = isTableCapacityTooHigh;
exports.isTableCapacitySuitable = isTableCapacitySuitable;
const MAX_CAPACITY_MULTIPLIER = 1;
const MIN_CAPACITY_MULTIPLIER = 0.8;
function isTableCapacityTooLow(tableCapacity, numberOfGuests) {
    const maxCapacity = tableCapacity * MAX_CAPACITY_MULTIPLIER;
    return numberOfGuests > maxCapacity;
}
function isTableCapacityTooHigh(tableCapacity, numberOfGuests) {
    const minCapacity = tableCapacity * MIN_CAPACITY_MULTIPLIER;
    return numberOfGuests < minCapacity;
}
function isTableCapacitySuitable(tableCapacity, numberOfGuests) {
    return !isTableCapacityTooLow(tableCapacity, numberOfGuests) && !isTableCapacityTooHigh(tableCapacity, numberOfGuests);
}
//# sourceMappingURL=isTableCapacitySuitable.js.map